import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=2145ace8&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&id=2145ace8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145ace8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/Resources.vue
// module id = null
// module chunks = 